function SortFunction() {
  const params = {
    asc: false,
  }
  return {
    by(name) {
      params.name = name
      return this
    },
    format(format) {
      params.format = format
      return this
    },
    get dateFormat() {
      params.format = Date.parse
      return this
    },
    get asc() {
      params.asc = true
      return this
    },
    get desc() {
      params.asc = false
      return this
    },
    get values() {
      return params
    },
    compare(a, b) {
      if (params.asc) {
        params.a = a
        params.b = b
      } else {
        params.a = b
        params.b = a
      }

      if (params.func) {
        if (params.name) {
          params.a = params.func(params.a[params.name])
          params.b = params.func(params.b[params.name])
        } else {
          params.a = params.func(params.a)
          params.b = params.func(params.b)
        }
      } else if (params.name) {
        params.a = params.a[params.name]
        params.b = params.b[params.name]
      }
      if (params.a > params.b) {
        return 1
      }
      if (params.a < params.b) {
        return -1
      }
      return 0
    },
  }
}

export default SortFunction
